"use strict";

/**
 * Loading external 360° modelson click on thumbnail
 */
{
    /** @type {HTMLDivElement} */
    // const externalModels = document.querySelectorAll('[data-external-model]');
    // externalModels.forEach((externalModel) => {
    //     externalModel.addEventListener('click', () => {
    //         const externalModelId = externalModel.getAttribute('data-media-id');
    //         if (externalModelId) {
    //             /** @type {HTMLDivElement} */
    //             const modelContainer = document.getElementById(`Media${ externalModelId }`);
    //             const modelScript = modelContainer.querySelector('script');
    //             const modelScriptUrl = modelScript.getAttribute('data-src');
    //             modelScript.setAttribute('src', modelScriptUrl);
    //             modelScript.removeAttribute('data-src');
    //         }
    //         externalModel.removeEventListener('click', () => { });
    //     });
    // });



    document.addEventListener('slide:active', (e) => {
        /** @type {HTMLDivElement} */
        const currentSlide = e.detail.slide;

        if (currentSlide.hasAttribute('data-custom-model')) {
            const customModelAttr = currentSlide.getAttribute('data-custom-model');
            if (customModelAttr != 'loaded') {
                const modelScript = currentSlide.querySelector('script');
                const modelScriptUrl = modelScript.getAttribute('data-src');
                modelScript.setAttribute('src', modelScriptUrl);
                modelScript.removeAttribute('data-src');

                currentSlide.setAttribute('data-custom-model','loaded');
            }
        }

    });

}